import React, { useState, useEffect } from 'react';
import DashboardLayout from '../components/DashboardLayout';
import { Activity } from 'lucide-react';
import { toast } from 'sonner';
import { supabase } from '../lib/supabase';

const AdminLogsPage = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    try {
      const { data, error } = await supabase
        .from('logs')
        .select('*')
        .order('created_at', { ascending: false })
        .limit(500);

      if (error) throw error;
      setLogs(data || []);
    } catch (error) {
      toast.error('Failed to fetch logs');
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <div className="space-y-8">
        <div>
          <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }} data-testid="admin-logs-title">
            Activity Logs
          </h1>
          <p className="text-base text-muted-foreground mt-1">{logs.length} recent activities</p>
        </div>

        {loading ? (
          <div className="text-center py-12">
            <p className="text-muted-foreground font-mono">Loading logs...</p>
          </div>
        ) : logs.length === 0 ? (
          <div className="text-center py-12 bg-card border border-border rounded-lg" data-testid="no-logs">
            <Activity className="w-16 h-16 text-muted-foreground mx-auto mb-4" />
            <h3 className="text-lg font-medium mb-2">No activity logs yet</h3>
            <p className="text-sm text-muted-foreground">Activity will appear here as users interact with the vault</p>
          </div>
        ) : (
          <div className="bg-card border border-border rounded-lg overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-muted/50 border-b border-border">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground">Timestamp</th>
                    <th className="px-6 py-3 text-left text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground">Action</th>
                    <th className="px-6 py-3 text-left text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground">IP Address</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-border">
                  {logs.map((log) => (
                    <tr key={log.id} className="hover:bg-muted/30 transition-colors duration-150" data-testid="log-row">
                      <td className="px-6 py-4 text-sm font-mono text-muted-foreground">
                        {new Date(log.created_at).toLocaleString()}
                      </td>
                      <td className="px-6 py-4 text-sm">{log.action}</td>
                      <td className="px-6 py-4 text-sm font-mono text-muted-foreground">
                        {log.ip_address || 'N/A'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default AdminLogsPage;
